import { render, staticRenderFns } from "./NewFormBuilder.vue?vue&type=template&id=2cefee0a&scoped=true"
import script from "./NewFormBuilder.vue?vue&type=script&lang=js"
export * from "./NewFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./NewFormBuilder.vue?vue&type=style&index=0&id=2cefee0a&prod&lang=scss&scoped=true"
import style1 from "./NewFormBuilder.vue?vue&type=style&index=1&id=2cefee0a&prod&lang=scss&scoped=true"
import style2 from "./NewFormBuilder.vue?vue&type=style&index=2&id=2cefee0a&prod&scoped=true&lang=scss"
import style3 from "./NewFormBuilder.vue?vue&type=style&index=3&id=2cefee0a&prod&scoped=true&lang=css"
import style4 from "./NewFormBuilder.vue?vue&type=style&index=4&id=2cefee0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefee0a",
  null
  
)

export default component.exports